export const keys = {
  all: ['projects'] as const,
  details: () => [...keys.all, 'detail'] as const,
  detail: (id: number) => [...keys.details(), id] as const,
  templatePreview: (id: number) => ['preview', id] as const,
};
